import { Component, PLATFORM_ID, Inject, OnInit, OnChanges, Input, ChangeDetectionStrategy, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common'
import { ImageItem } from '../image-item/image-item.component';
import { RowHeader } from '../row-header/row-header.component';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';
@Component({
    selector: 'people-list',
    templateUrl: './people-list.component.html',
    styleUrls: ['./people-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PeopleList {
    @Input() item : any;
    @Input() showHeader : boolean = true;
    @Input() showCount : boolean = true;
    @Input() invert: boolean = false;
    @Input() small : boolean = false;
    @Input() showTitle : boolean = true;
    @Input() row : boolean = false;
    private dataService: BehaviorSubject<Object>;
    private isServer:boolean = false;
    /**
     * Item Row Component
     */
    constructor(
        @Inject(PLATFORM_ID) private platformId: string,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
        private coreEffects: CoreEffects,
        private ref: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router : Router
    ) {
        this.isServer = isPlatformServer(this.platformId);
    }

    ngOnInit() {
            
    }
    
    public fetchPeopleImage(item:any):string
    {
        const meta = item.meta;
        if( meta.obj_type == "mock" ){
            return;
        }
        if(meta.obj_type == 'Episode')
        {
            return 'url('+this.findPeopleImage(meta.video)+')';
        }

        return 'url('+this.findPeopleImage(item)+')';
        
    }
    private findPeopleImage(item:any):string{
        
        const meta = item.meta;
        let image:any = meta.images.find((obj) => { return obj.name == "people_thumb_416x" });

        if(image == null && meta.series)
        {
            image = meta.series.images.find((obj) => { return obj.name == "people_thumb_416x" });
        }

        if(image == null)
        {
            image = meta.images.find((obj) => { return obj.name == "thumb_416x" });
        }

        if(image == null)
        {
            return '/images/Default.jpg';
        }

        return image.url;
    }

    ngOnChanges(changes: SimpleChanges) {
      
    }  

    ngOnDestroy(): void {
        if (this.dataService){
            this.dataService.complete();
            //this.dataService.unsubscribe();
            this.dataService = null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/people-list/people-list.component.ts